import ProductModal from './ProductModal.view';

export default ProductModal;
